import { AppLink } from './AppLink';

const ROW = 'flex justify-between gap-4 py-[15px] text-[1.0625rem] font-semibold';

// One downloadable document: title (+ small meta line) on the left, arrow right.
// Without a file the row is plain text with "PDF soon" instead of a dead link.
export function DocRow({ title, meta, href }: { title: string; meta?: string; href?: string }) {
  const text = (
    <span>
      {title}
      {meta && <span className="mt-0.5 block font-mono text-[0.75rem] font-medium text-muted">{meta}</span>}
    </span>
  );
  return (
    <li className="border-b border-rule">
      {href ? (
        <AppLink href={href} className={`${ROW} text-ink no-underline hover:text-teal-700`}>
          {text}
          <span aria-hidden="true" className="text-teal-700">↓</span>
        </AppLink>
      ) : (
        <div className={`${ROW} text-ink`}>
          {text}
          <span className="flex-none font-mono text-[0.75rem] font-medium text-muted">PDF soon</span>
        </div>
      )}
    </li>
  );
}
